import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { AssetStatusUpsertArrayModel } from '../../asset/components/model/bulk-add-asset-status-array.model';

/**
 * @name BulkAddAssetStatusService
 */
@Injectable()
export class BulkAddAssetStatusService {
  private endpointUpsert = RestApiModel.STARGATE_API_URL + '/assetStatusUpsert';
  // Resolve HTTP using the constructor
  constructor(private http: HttpClient) {}

  /**
   * Post BulkAssetUpsert
   * @param {AssetStatusUpsertModel} AssetStatusUpsertModel
   * @returns {Observable<any>}
   */
  assetStatusUpsert(
    StatusUpsertArrayModel: AssetStatusUpsertArrayModel
  ): Observable<any> {
    return this.http.post(
      this.endpointUpsert,
      StatusUpsertArrayModel
    ) as Observable<any>;
  }
}
